import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api, toApiErrorMessage} from "utils/http"

interface DataProps {
    id: number
}

export const approveApplication = createAsyncThunk<
    void,
    DataProps,
    AppThunkProps & {rejectValue: string | undefined}
>("application/approve", async ({id}, {signal, rejectWithValue}) => {
    try {
        await api.patch<void>(`/applications/${id}/acceptance`, undefined, {signal})
    } catch (error) {
        // Без rejectWithValue текст ошибки от бэкенда теряется при сериализации
        return rejectWithValue(toApiErrorMessage(error))
    }
})
